import { useScrollTo } from '@/hooks/useScrollTo';

export default function Hero() {
  const scrollTo = useScrollTo();

  return (
    <section
      id="hero"
      className="relative min-h-[600px] md:min-h-[700px] flex items-center overflow-hidden"
    >
      <div className="absolute inset-0">
        <img
          src="https://readdy.ai/api/search-image?query=Stylized%20abstract%20cinematic%20composition%20with%20floating%20film%20strips%20and%20glowing%20circular%20frames%2C%20warm%20coral%20and%20amber%20gradient%20tones%2C%20dark%20atmospheric%20background%2C%20modern%20entertainment%20streaming%20aesthetic%2C%20soft%20bokeh%20light%20effects%2C%20artistic%20movie-themed%20illustration%2C%20clean%20minimalist%20composition%20with%20depth%20and%20texture&width=1600&height=900&seq=hero-bg-nc&orientation=landscape"
          alt="嫩草视频影视聚合平台"
          className="w-full h-full object-cover"
        />
      </div>
      <div className="absolute inset-0 bg-gradient-to-b from-black/50 via-black/35 to-black/60"></div>

      <div className="relative z-10 w-full max-w-[1400px] mx-auto px-4 md:px-6">
        <div className="flex flex-col lg:flex-row items-center gap-10 lg:gap-16">
          <div className="flex-1 w-full text-center lg:text-left">
            <div className="inline-flex items-center gap-2 px-4 py-1.5 rounded-full bg-background-50/15 backdrop-blur-sm border border-background-50/20 mb-6">
              <i className="ri-fire-line text-accent-400 text-sm"></i>
              <span className="text-background-50/90 text-sm font-medium whitespace-nowrap">每日更新 · 高清无广告 · 追剧神器</span>
            </div>

            <h1 className="font-heading text-3xl md:text-5xl lg:text-6xl text-background-50 leading-tight mb-4">
              嫩草视频
              <span className="block text-2xl md:text-3xl lg:text-4xl font-body font-light mt-2">
                聚合全网热播影视高清在线观看平台
              </span>
            </h1>

            <p className="text-background-50/80 font-body text-base md:text-lg mb-2">
              妖精视频 · 桃花视频 · 苹果视频 · 榴莲视频 一站看遍
            </p>

            <p className="text-background-50/70 text-sm md:text-base leading-relaxed max-w-xl mx-auto lg:mx-0 mb-8">
              嫩草视频致力于为追剧爱好者打造一站式影视聚合入口，实时同步妖精视频、桃花视频、苹果视频、榴莲视频、豆花视频等主流平台最新资源。
              无论是最新电视剧完整版高清在线观看，还是经典电影大全重温，这里都能满足你的追剧需求。每日海量更新，告别多个 App 来回切换的烦恼，
              一部手机畅享全网热播内容，追剧不等待。
            </p>

            <div className="flex flex-wrap items-center justify-center lg:justify-start gap-6 md:gap-10 mb-8">
              <div className="text-center">
                <div className="text-accent-400 font-heading text-2xl md:text-3xl">200+</div>
                <div className="text-background-50/60 text-xs md:text-sm">每日更新剧集</div>
              </div>
              <div className="text-center">
                <div className="text-accent-400 font-heading text-2xl md:text-3xl">12</div>
                <div className="text-background-50/60 text-xs md:text-sm">聚合视频平台</div>
              </div>
              <div className="text-center">
                <div className="text-accent-400 font-heading text-2xl md:text-3xl">1080P</div>
                <div className="text-background-50/60 text-xs md:text-sm">高清画质保证</div>
              </div>
            </div>

            <div className="flex flex-col sm:flex-row items-center justify-center lg:justify-start gap-3">
              <button
                onClick={() => scrollTo('media')}
                className="px-8 py-3 bg-primary-500 hover:bg-primary-600 text-background-50 font-medium rounded-full whitespace-nowrap cursor-pointer transition-all text-sm md:text-base w-full sm:w-auto"
              >
                <i className="ri-play-circle-fill mr-2"></i>
                立即追剧
              </button>
              <button
                onClick={() => scrollTo('ranking')}
                className="px-8 py-3 bg-background-50/15 hover:bg-background-50/25 backdrop-blur-sm text-background-50 border border-background-50/30 font-medium rounded-full whitespace-nowrap cursor-pointer transition-all text-sm md:text-base w-full sm:w-auto"
              >
                <i className="ri-trophy-line mr-2"></i>
                查看热播榜单
              </button>
            </div>
          </div>

          <div className="flex-1 w-full max-w-[500px] lg:max-w-none">
            <div className="relative rounded-2xl overflow-hidden shadow-2xl shadow-black/30">
              <img
                src="https://readdy.ai/api/search-image?query=Warm%20toned%20cinematic%20entertainment%20collage%20with%20floating%20movie%20posters%20and%20video%20player%20interface%20elements%2C%20modern%20Chinese%20drama%20streaming%20platform%20aesthetic%2C%20soft%20coral%20and%20gold%20accents%2C%20glass%20morphism%20style%20overlay%20panels%2C%20abstract%20geometric%20shapes%20with%20warm%20gradients%2C%20premium%20digital%20media%20design%2C%20clean%20artistic%20visualization&width=600&height=500&seq=hero-side-nc&orientation=landscape"
                alt="嫩草视频影视聚合 - 热播剧集精彩呈现"
                className="w-full h-auto object-cover"
              />
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}